const doc = [({"ja":({"indexTitle":"LPコンテンツ一覧", "newTitle":"LPコンテンツ作成", "editTitle":"LPコンテンツ編集"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;